import { hiringManagerMentorJobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showSuccessMessage, showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

// get accept reject
export const get_accept_reject_mentor_hiring_manager_action =
  (id) => async (dispatch) => {
    dispatch({
      type: hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.acceptRejectMentor.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerMentorJobsConstants.GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      
    }
  };

// accept reject mentor
export const accept_reject_mentor_hiring_manager_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: hiringManagerMentorJobsConstants.ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.acceptRejectMentor.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: hiringManagerMentorJobsConstants.ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        if (data.application_status == "selected") {
          showSuccessMessage("Mentor Selected.")
        } else showWarningMessage("Mentor Rejected.")
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerMentorJobsConstants.ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage("Having some issue in assigning mentor.")
    }
  };

//all mentors applied
export const get_all_mentors_applied_hiring_manager_action =
  (id) => async (dispatch) => {
    dispatch({
      type: hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.allMentorsApplied.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerMentorJobsConstants.GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//all mentors applied
export const get_suggested_mentors_hiring_manager_action =
  (data) => async (dispatch) => {
    dispatch({
      type: hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.hiringManager.allSuggestedMentors,
        data
      );
      if (response.status) {
        dispatch({
          type: hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerMentorJobsConstants.GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

  //all mentors applied
export const view_mentor_public_profile_hiring_manager_action =
(id) => async (dispatch) => {
  dispatch({
    type: hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.hiringManager.viewMentorPublicProfile.replace(':id',id)
    );
    if (response.status) {
      dispatch({
        type: hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: hiringManagerMentorJobsConstants.VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//all applied mentors list
export const get_all_applied_mentor_list_action = () => async (dispatch) => {
  dispatch({
      type: hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_REQUEST
  });
  try {
      const response = await axiosInstance.get(config.hiringManager.getAllAppliedMentor)
      if (response.status) {
          dispatch({
              type: hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_SUCCESS,
              payload: response.data,
          });
          return response.data;
      } else {
          return false;
      }
  } catch (e) {
      dispatch({
          type: hiringManagerMentorJobsConstants.GET_ALL_APPLIED_MENTOR_ACTION_FAILURE,
          payload: e.msg
      });
  }
};